import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StoryblokService } from './services/storyblok.service';

export const storyblokPreventNavInEditModeGuard: CanActivateFn = () => {
  return !inject(StoryblokService).storyblokInstance?.isInEditor();
};
